// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { floatingTooltipStyles } from "@awc/App/Components/FloatingTooltip/FloatingTooltip";
import { color, getSystemColor } from "@awc/XDL/Utilities";
import { ButtonIcon } from "@insite/mobius/Button";
import { getProp } from "@insite/mobius/utilities";
import { css } from "styled-components";

floatingTooltipStyles.tooltipContent = {
    css: css`
        background-color: ${color("common.ui1")};
        z-index: ${getProp("theme.zIndex.tooltip")};
        box-shadow: 0 2px 4px 0 ${color("common.ui7", 0.1)};
        padding: 12px;
        max-width: 250px;
        border: 1px solid ${color("common.border")};
        svg {
            fill: ${color("common.ui1")};
            stroke: ${color("common.border")};
            stroke-width: 0;
        }
    `,
};

floatingTooltipStyles.tooltipArrow = {
    width: 16,
    height: 10,
    fill: `${getSystemColor("common.ui1")}`,
    stroke: `${getSystemColor("common.border")}`,
    strokeWidth: 1,
};

floatingTooltipStyles.drawerContent = {
    css: css`
        background-color: ${color("common.ui1")};
        display: flex;
        position: fixed;
        flex-direction: column;
        right: -400px;
        top: 0;
        height: 100vh;
        padding: 16px;
        width: 332px;
        z-index: ${getProp("theme.zIndex.drawer")};
        transition: right 0.5s ease-in-out;

        ${({ isMounted }: any) =>
            isMounted &&
            css`
                right: 2px;
            `}
    `,
};

floatingTooltipStyles.drawerClose = {
    variant: "link" as any,
    css: css`
        margin: 0 0 8px auto;
        ${ButtonIcon} {
            color: ${color("common.ui7")};
        }
    `,
};
